<app-layer-config-collapsible-category description="Speed signs" storageKey="vzo-clustered-signs">
  <app-layer-control-item
    *hasPermissionAny="[Permissions.VZO_ClusteredSigns_Read]"
    description="Clustered Signs"
    [isLayerVisibile]="isClusteredSignsVisible"
    [layerId]="layerIds.ClusteredSigns.name"
    icon="arrows-collapse-object"
    (visibilityToggled)="toggleLayerVisbility($event)"
  ></app-layer-control-item>
  <app-layer-control-item
    *hasPermissionAny="[Permissions.VZO_ClusteredSigns_Read]"
    description="Non-Detections"
    [isLayerVisibile]="isNonDetectionsVisible"
    [layerId]="layerIds.NonDetections.name"
    icon="arrows-collapse-object"
    (visibilityToggled)="toggleLayerVisbility($event)"
  ></app-layer-control-item>
  <app-layer-control-item
    *hasPermissionAny="[Permissions.VZO_MatchedSigns_Read]"
    description="Matched Signs"
    [isLayerVisibile]="isMatchedSignsLayerVisible"
    [layerId]="layerIds.MatchedSigns.name"
    icon="speedlimit-80-dirty"
    (visibilityToggled)="toggleLayerVisbility($event)"
  ></app-layer-control-item>
  <app-layer-control-item
    description="Blacklist Areas"
    [isLayerVisibile]="isBlacklistAreaLayerVisible"
    [layerId]="layerIds.BlacklistAreas.name"
    icon="heatmap"
    (visibilityToggled)="toggleLayerVisbility($event)"
  ></app-layer-control-item>
</app-layer-config-collapsible-category>
